import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateModule } from '@ngx-translate/core';
import { TraductionService } from '../traduction.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { AbstractSigaleComponent } from '../../abstract-sigale.component';
import { ButtonModule } from 'primeng/button';
import { AlertService } from '../../alert/alert.service';

@Component({
	standalone: true,
	selector: 'diffuser-elements-traduisibles',
	templateUrl: './diffuser-elements-traduisibles.component.html',
	styleUrls: ['./diffuser-elements-traduisibles.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		ToastModule,
		ButtonModule
	]
})
export class DiffuserElementsTraduisiblesComponent extends AbstractSigaleComponent {

	readonly toastKey: string = 'diffuserElementsTraduisiblesComponentToastKey';

	constructor(private traductionService: TraductionService,
				private messageService: MessageService,
				private alertService: AlertService) {
		super();
	}

	/**
	 * Diffuse les elements traduisibles
	 */
	diffuserElementsTraduisibles(): void {
		this.alertService.clear(this.nomAlert);
		this.traductionService.exporterTraductions().subscribe(
			() => this.messageService.add({
				key: this.toastKey,
				severity: 'success',
				detail: this.translateService.instant('SIGALE_ANGULAR.COMPONENTS.TRADUCTION.DIFFUSER_ELEMENTS.ELEMENTS_TRADUISIBLES_DIFFUSES')
			}),
			err => this.alertService.error(err.error, this.nomAlert)
		);
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"TRADUCTION": {
						"DIFFUSER_ELEMENTS": {
							"TITRE_LEGEND": "Diffusion des éléments à traduire",
							"SUCCES": "Opération réussie",
							"MESSAGE_DIFFUSION": "Ceci permet de diffuser à l'application Sigale Traduction les éléments à traduire.",
							"TITLE_BTN_DIFFUSION": "Diffuse les éléments traduisibles à l'application Traduction",
							"BTN_DIFFUSER": "Diffuser les éléments traduisibles",
							"ELEMENTS_TRADUISIBLES_DIFFUSES": "Les éléments traduisibles ont été diffusés à l'application Traduction"
						}
					}
				}
			}
		};
	}

	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"TRADUCTION": {
						"DIFFUSER_ELEMENTS": {
							"TITRE_LEGEND": "Diffusione degli elementi da tradurre",
							"SUCCES": "Operazione riuscita",
							"MESSAGE_DIFFUSION": "Questo permette di inviare all'applicazione Sigale Traduzione gli elementi da tradurre.",
							"TITLE_BTN_DIFFUSION": "Invia gli elementi traducibili all'applicazione Traduzione",
							"BTN_DIFFUSER": "Inviare gli elementi traducibili",
							"ELEMENTS_TRADUISIBLES_DIFFUSES": "Gli elementi traducibili sono stati diffusi all'applicazione Traduzione"
						}
					}
				}
			}
		};
	}

}
